module.exports = _.pullAll;